import React from 'react';
import { swatchStyle } from '../../../utils/drillz/listValueVisuals';

const QuicklogRockSwatch = ({ visual, sizePx = 12, useTextureImg = false }) => {
  if (useTextureImg && visual?.texture?.dataUrl) {
    return (
      <img
        src={visual.texture.dataUrl}
        alt=""
        style={{
          ...swatchStyle(visual, sizePx),
          display: 'block',
          objectFit: 'cover',
        }}
      />
    );
  }

  return <span style={swatchStyle(visual, sizePx)} aria-hidden="true" />;
};

export default QuicklogRockSwatch;
